import Image from "next/image";
import React from "react";

interface LogoProps {
  onClick?: () => void;
  className?: string;
}

const Logo = (props: LogoProps) => {
  const { onClick, className } = props;
  const logoClassName = ["w-[100px] sm:w-[130px] h-auto", className].filter(Boolean).join(" ");

  return (
    <div className="cursor-pointer" onClick={onClick}>
      <Image
        src="/assets/images/logo/logo.svg"
        width={214}
        height={90}
        alt="logo"
        className={logoClassName}
        priority
      />
    </div>
  );
};

export default Logo;
